import { useNavigate } from "react-router-dom";

export default function useLogout() {
  const navigate = useNavigate();

  const logOut = () => {
    localStorage.removeItem("loginData");
    navigate("/authentication/sign-in");
  };

  return logOut;
}
